__webpack_require__.p = "/kurser/webbprogrammering-pa-klientsidan-ht25/";